import { FITNESS_VILLAGE_MESSAGES_AR } from './fitnessVillageCopy.ar';
import { DfcLocale } from './dfcLocale';

/** The Arabic for a shared English message, or the English itself when there is none. */
export const translateDfcMessage = (english: string, locale: DfcLocale): string =>
  locale === 'ar' ? (FITNESS_VILLAGE_MESSAGES_AR[english] ?? english) : english;

/**
 * For messages raised outside React's render — toasts, form errors set in a handler. The page's
 * `<html lang>` is the language: `DfcDirectionProvider` sets it to "ar" only on the DFC village
 * in Arabic, so every other company gets its English back unchanged. Render-time text uses
 * `useLocalizeMessage()` instead, which follows the language switch on the same render.
 */
export const localizeMessage = (english: string): string =>
  translateDfcMessage(english, document.documentElement.lang === 'ar' ? 'ar' : 'en');
